<template>
  <b-row class="px-3 my-2">
    <b-col cols="8">
      <b-row>
        <b-col cols="9">
          <b-form-group label="Název:" label-for="inputName">
            <b-form-input
              v-model="$store.getters.selectionSelect.name"
              id="inputName"
              type="text"
              size="sm"
              :disabled="$store.getters.selectionShowClosed"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-checkbox
            class="pt-3 mt-4 float-right"
            v-model="$store.getters.selectionSelect.closedFlag"
            switch
          >Uzavřeno</b-form-checkbox>
        </b-col>
      </b-row>
      <b-form-group label="Poznámka:" label-for="inputDescription">
        <b-form-textarea
          id="inputDescription"
          v-model="$store.getters.selectionSelect.description"
          rows="4"
          max-rows="4"
          no-resize
          :disabled="$store.getters.selectionShowClosed"
          size="sm"
        />
      </b-form-group>
    </b-col>

    <b-col cols="2">
      <div class="my-4"/>
      <b-row class="mx-0">
        <b-button
          @click="updateSelection"
          variant="primary"
          size="sm"
          class="my-2 btn-block"
        >Uložit změny</b-button>
      </b-row>
      <b-row v-if="!$store.getters.selectionShowClosed" class="mx-0">
        <b-button
          variant="success"
          size="sm"
          class="my-2 btn-block"
          @click="selectionSMSModal"
        >Odeslat SMS</b-button>
      </b-row>
      <b-row v-if="$store.getters.selectionShowClosed" class="mx-0">
        <b-button
          variant="success"
          size="sm"
          v-b-modal.copyModal
          @click="copyData = JSON.parse ( JSON.stringify ($store.getters.selectionSelect))"
          class="my-2 btn-block"
        >Nová kopie</b-button>
      </b-row>
    </b-col>

    <b-col cols="2">
      <div class="my-4"/>
      <b-row class="mx-0">
        <b-button
          @click="$bvModal.show('expDocModal'), expDocAmount=0,expDocPurpose='',expDocReserve=0,expDocVat=21"
          variant="warning"
          size="sm"
          class="my-2 btn-block"
        >Výdajové doklady</b-button>
      </b-row>
      <b-row class="mx-0">
        <b-button
          type="submit"
          variant="warning"
          size="sm"
          class="my-2 btn-block"
          v-b-modal.reportModal
          disabled
        >PDF</b-button>
      </b-row>
      <b-row class="mx-0">
        <b-col class="p-0 btn-block" cols="9">
          <b-button
            type="submit"
            variant="warning"
            size="sm"
            class="my-2 btn-block"
            @click="exportExcel"
          >Export Excel</b-button>
        </b-col>
        <b-col cols="3">
          <b-form-checkbox
            class="my-2 pt-1 btn-block"
            v-model="excelConfirmedOnly"
            v-b-popover.hover="'Jenom potvrzené osoby'"
            switch
          />
        </b-col>
      </b-row>
    </b-col>

    <b-modal id="copyModal" title="Kopie výběru">
      <b-form-group label="Název:" label-for="inputNameModal">
        <b-form-input v-model="copyData.name" id="inputNameModal" type="text" size="sm" required/>
      </b-form-group>

      <b-form-group label="Poznámka:" label-for="inputDescriptionModal">
        <b-form-textarea
          id="inputDescriptionModal"
          v-model="copyData.description"
          rows="5"
          max-rows="6"
          size="sm"
        />
      </b-form-group>

      <template slot="modal-footer">
        <b-button size="sm" variant="success" @click="createCopy()">Uložit</b-button>
        <b-button size="sm" variant="danger" @click="$bvModal.hide('copyModal')">Zrušit</b-button>
      </template>
    </b-modal>

    <b-modal id="reportModal" size="xl" :title="`Report: ${$store.getters.selectionSelect.name}`">
      <GalleryReport/>
      <template slot="modal-footer">
        <b-button variant="success" size="sm" class="my-2">PDF</b-button>
      </template>
    </b-modal>

    <b-modal id="expDocModal" :title="`Výdajový doklad: ${$store.getters.selectionSelect.name}`">
      <b-row>
        <b-col cols="8">
          <b-form-group label="Částka s DPH:" label-for="expDocAmount">
            <b-form-input v-model.number="expDocAmount" id="expDocAmount" type="number"/>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="DPH % :" label-for="expDocVat">
            <b-form-input v-model.number="expDocVat" id="expDocVat" type="number"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label="Účel platby:" label-for="expDocPurpose">
        <b-form-input v-model="expDocPurpose" id="expDocPurpose" type="text"/>
      </b-form-group>
      <b-form-group label="Rezervní doklady:" label-for="expDocReserve">
        <b-form-input v-model.number="expDocReserve" id="expDocReserve" type="number"/>
      </b-form-group>
      <template slot="modal-footer">
        <b-button variant="success" size="sm" class="my-2" @click="expenditureForm">Stáhnout</b-button>
        <b-button
          variant="primary"
          size="sm"
          class="my-2"
          @click="$bvModal.hide('expDocModal')"
        >Zavřít</b-button>
      </template>
    </b-modal>

    <b-modal
      id="selectionSMSModal"
      size="lg"
      :title="`SMS pro výběr: ${$store.getters.selectionSelect.name}`"
    >
      <h3>Text SMS:</h3>
      <b-form-textarea v-model="selectionSMSText" id="inputSMS" rows="6" max-rows="6"/>
      <b-row class="ml-1">
        Znaků: {{countSMS(selectionSMSText).length}} &nbsp;&nbsp;&nbsp;&nbsp;
        Zústává: {{countSMS(selectionSMSText).remaining}} &nbsp;&nbsp;&nbsp;&nbsp;
        Počet zpráv: {{countSMS(selectionSMSText).messages}} &nbsp;&nbsp;&nbsp;&nbsp;
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-form-checkbox v-model="peopleConfirmedSMS" switch>Potvrzený</b-form-checkbox>
        </b-col>
        <b-col cols="7">
          <b-form-checkbox v-model="peopleUnconfirmedSMS" switch>Nepotvrzený</b-form-checkbox>
        </b-col>
        <b-col cols="2">
          <b-form-checkbox v-model="peopleFlashSMS" switch>Flash&nbsp;SMS</b-form-checkbox>
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button variant="danger" class="my-2" @click="$bvModal.hide('selectionSMSModal')">Zrušit</b-button>
        <b-button variant="success" class="my-2" @click="sendSelectionSMS">Odeslat</b-button>
      </template>
    </b-modal>
    <span class="ml-3">Počet lidí ve výběru: &nbsp;{{$store.getters.cards.length}}</span>
  </b-row>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import GalleryReport from '@/components/galleryReport.vue'
import SmsCounter from 'sms-counter'

export default Vue.extend({
  name: 'selectionForm',
  components: {
    GalleryReport
  },
  data () {
    return {
      excelConfirmedOnly: false,
      pdfConfirmedOnly: false,
      peopleFlashSMS: false,
      selectionSMSText: '',
      peopleConfirmedSMS: true,
      peopleUnconfirmedSMS: false,
      disableEdit: true,
      disableClose: true,
      disableSMS: true,
      closeSelectionCheckbox: false,
      copyData: {},
      expDocAmount: 0,
      expDocPurpose: '',
      expDocReserve: 0,
      expDocVat: 21
    }
  },
  methods: {
    countSMS (sendSMSMessage) {
      return SmsCounter.count(sendSMSMessage)
    },
    updateSelection () {
      axios.put('/api/v1/selection/' + this.$store.getters.selectionSelect.id, this.$store.getters.selectionSelect)
        .then(response => {
          axios
            .get('/api/v1/selection', {
              params: {
                closed: this.$store.getters.selectionShowClosed // Ak sa zobrazuju uzavrete tak refreshni uzavrete
              }
            })
            .then(response => (this.$store.commit('selection', response.data)))
          // Pri uzavreni otvoreneho vyberu premaz formular
          if (this.$store.getters.selectionSelect.closedFlag === true) {
            this.$store.commit('cards', [])
            this.$store.commit('selectionSelect', {})
          }
          // Pri zmene Statusu uzavreteho vyberu premaz formular
          if (this.$store.getters.selectionShowClosed === true) {
            this.$store.commit('cards', [])
            this.$store.commit('selectionSelect', {})
          }
          this.$bvToast.toast(`Uloženo`, {
            title: 'Uložení výběru',
            variant: 'success',
            autoHideDelay: 1000
          })
        })
        .catch(response => {
          alert('updateError: ' + response.data)
        })
    },
    createCopy () {
      this.copyData.duplicate = this.copyData.id
      this.copyData.closedFlag = false
      axios
        .post(`/api/v1/selection`, this.copyData)
        .then(response => {
          this.$bvModal.hide('copyModal')
          this.$bvToast.toast(`Uloženo`, {
            title: 'Uložení nového výběru',
            variant: 'success',
            autoHideDelay: 1000
          })
        })
        .catch(response => {
          console.log('copy error: ', response.data)
        })
    },
    selectionSMSModal () {
      this.selectionSMSText = ''
      this.peopleFlashSMS = false
      this.peopleConfirmedSMS = true
      this.peopleUnconfirmedSMS = false
      this.$bvModal.show('selectionSMSModal')
    },
    sendSelectionSMS () {
      if (this.selectionSMSText === '') {
        this.$bvToast.toast(`Nebyl vyplněn text!!!`, {
          title: 'ERROR:',
          variant: 'danger',
          autoHideDelay: 2500
        })
      } else {
        if (!this.peopleUnconfirmedSMS && !this.peopleConfirmedSMS) {
          this.$bvToast.toast(`Musí být zvolena alespoň jedna kategorie (Potvrzený, Nepotvrzený)`, {
            title: 'ERROR:',
            variant: 'danger',
            autoHideDelay: 2500
          })
        } else {
          axios
            .post('/api/v1/sms/selection', {
              id: this.$store.getters.selectionSelect.id,
              text: this.selectionSMSText,
              flash_sms: this.peopleFlashSMS,
              confirmed: this.peopleConfirmedSMS,
              unconfirmed: this.peopleUnconfirmedSMS
            })
            .then(response => {
              if (response.data.message === 'OK') {
                this.$bvModal.hide('selectionSMSModal')
                this.$bvToast.toast(`Odeslání proběhlo v pořádku`, {
                  title: 'Odeslání SMS',
                  variant: 'success',
                  autoHideDelay: 1500
                })
              }
            })
            .catch(() => {
              this.$bvToast.toast(`Chyba při odesílání SMS`, {
                title: 'Odeslání SMS',
                variant: 'danger',
                autoHideDelay: 1500
              })
            })
        }
      }
    },
    exportExcel () {
      axios({
        url: `/api/v1/export/selection/${this.$store.getters.selectionSelect.id}/xlsx`,
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) { fileName = fileNameMatch[1] }
        }
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      })
    },
    expenditureForm () {
      // console.log({ amount: this.expDocAmount, purpose: this.expDocPurpose, reserve: this.expDocReserve })
      axios({
        url: `/api/v1/template/render/expenditure-document/${this.$store.getters.selectionSelect.id}`,
        params: {
          amount: this.expDocAmount,
          vat: this.expDocVat,
          purpose: this.expDocPurpose,
          reserve: this.expDocReserve
        },
        method: 'GET',
        responseType: 'blob' // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unknown'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) { fileName = fileNameMatch[1] }
        }
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        this.$bvModal.hide('expDocModal')
      }).catch(response => {
        this.$bvToast.toast(`Ve výběru pravděpodobně není žádná potvrzená osoba `, {
          title: 'ERROR:',
          variant: 'danger',
          autoHideDelay: 2500
        })
      })
    }
  }
})
</script>

<style>
</style>
